import styled from "styled-components";

const Row = styled.div.withConfig({
  displayName: "Row",
})`
  display: flex;
  flex-direction: row;
`;

export default Row;
